import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import history from '../utils/history';

import uiReducer from './uiReducer';
import usersReducer from './usersReducer';
import userTypesReducer from './userTypesReducer';
import userFilterFieldsReducer from './userFilterFieldsReducer';

import passwordPoliciesReducer from './passwordPoliciesReducer';
import rolesReducer from './rolesReducer';
import roleFilterFieldsReducer from './roleFilterFieldsReducer';
import permissionsReducer from './permissionsReducer';
import customFieldsReducer from './customFieldsReducer';
import customFieldDataTypesReducer from './customFieldDataTypesReducer';
import customFieldValidationRulesReducer from './customFieldValidationRulesReducer';
import customFieldModulesReducer from './customFieldModulesReducer';
import departmentsReducer from './departmentsReducer';
import departmentFilterFieldsReducer from './departmentFilterFieldsReducer';
import operatorsReducer from './operatorsReducer';
import operatorChartsReducer from './operatorChartsReducer';
import operatorGroupsReducer from './operatorGroupsReducer';
import operatorFilterFieldsReducer from './operatorFilterFieldsReducer';
import branchesReducer from './branchesReducer';
import branchFilterFieldsReducer from './branchFilterFieldsReducer';
import entitySummariesReducer from './entitySummariesReducer';
import appReportsReducer from './appReportsReducer';
import appChartsReducer from './appChartsReducer';
import appReportDetailsReducer from './appReportDetailsReducer';
import appReportFilterFieldsReducer from './appReportFilterFieldsReducer';
import transactionCountsReducer from './transactionCountsReducer';
import {
  allCountAmountTransactionReducer,
  allTransactionReducer,
  countAmountTransactionSummaryReducer,
  hitCountTransactionReducer,
  monthlyCountAmountTransactionReducer,
  monthlytransactionReducer,
  todayCountAmountTransactionReducer,
  todaytransactionReducer,
  transactionPaymentReducer,
  transactionReducer,
  watchListTransactionReducer,
} from './transactionReducer';
import activityLogReducer from './activityLogReducer';
import auditLogReducer from './auditLogReducer';
import transactionFilterFieldsReducer from './transactionFilterFieldsReducer';
import transactionSummariesReducer from './transactionSummariesReducer';
import transactionRulesReducer from './transactionRulesReducer';
import transactionRuleAppsReducer from './transactionRuleAppsReducer';
import transactionRuleApplicableGroupsReducer from './transactionRuleApplicableGroupsReducer';
import transactionRuleCommissionBasisReducer from './transactionRuleCommissionBasisReducer';
import transactionRuleCommissionTypesReducer from './transactionRuleCommissionTypesReducer';
import transactionRuleFeeChargesReducer from './transactionRuleFeeChargesReducer';
import transactionRuleFilterFieldsReducer from './transactionRuleFilterFieldsReducer';

import { terminalsReducer, terminalKcvReducer } from './terminalsReducer';

import terminalTypesReducer from './terminalTypesReducer';
import terminalLocationsReducer from './terminalLocationsReducer';
import terminalInstalledAppsReducer from './terminalInstalledAppsReducer';
import terminalInstalledAppEventsReducer from './terminalInstalledAppEventsReducer';
import terminalInstalledAppLogsReducer from './terminalInstalledAppLogsReducer';
import terminalFilterFieldsReducer from './terminalFilterFieldsReducer';
import terminalLocksReducer from './terminalLocksReducer';
import terminalGeoFencingsReducer from './terminalGeoFencingsReducer';
import customersReducer from './customersReducer';
import customerFilterFieldsReducer from './customerFilterFieldsReducer';
import customerEnrollmentsReducer from './customerEnrollmentsReducer';
import mtoReducer from './mtoReducer';
import mtoFilterFieldsReducer from './mtoFilterFieldsReducer';
import countriesReducer from './countriesReducer';
import messagingReducer from './messagingReducer';
import messagingFilterFieldsReducer from './messagingFilterFieldsReducer';
import messagingParameterTypesReducer from './messagingParameterTypesReducer';
import appsReducer from './appsReducer';
import appCategoryChartsReducer from './appCategoryChartsReducer';
import appFilterFieldsReducer from './appFilterFieldsReducer';
import platformCertificatesReducer from './platformCertificatesReducer';
import platformCertificateFilterFieldsReducer from './platformCertificateFilterFieldsReducer';
import firmwaresReducer from './firmwaresReducer';
import firmwareFilterFieldsReducer from './firmwareFilterFieldsReducer';
import appBroadcastsReducer from './appBroadcastsReducer';
import userDetailsReducer from './userDetailsReducer';
import switchesReducer from './switchesReducer';
import switchTypesReducer from './switchTypesReducer';
import switchKeyEncryptionTypesReducer from './switchKeyEncryptionTypesReducer';
import switchKeyCertificateFactoryTypesReducer from './switchKeyCertificateFactoryTypesReducer';
import switchKeyVersionsReducer from './switchKeyVersionsReducer';
import switchFilterFieldsReducer from './switchFilterFieldsReducer';
import integrationCodeTypesReducer from './integrationCodeTypesReducer';
import generalSettingsReducer from './generalSettingsReducer';
import systemSettingsReducer from './systemSettingsReducer';
import terminalResetsReducer from './terminalResetsReducer';
import terminalModelsReducer from './terminalModelsReducer';
import terminalModelFilterFieldsReducer from './terminalModelFilterFieldsReducer';
import terminalLocationEventsReducer from './terminalLocationsEventReducer';
import accountTypesReducer from './accountTypesReducer';
import productTypesReducer from './productTypesReducer';
import channelsReducer from './channelsReducer';
import channelFilterFieldsReducer from './channelFilterFieldsReducer';
import channelTypesReducer from './channelTypesReducer';
import channelMethodTypesReducer from './channelMethodTypesReducer';
import channelProtocolTypesReducer from './channelProtocolTypesReducer';
import channelActionOnRuleViolationTypesReducer from './channelActionOnRuleViolationTypesReducer';
import sanctionListDetailReducer from './sanctionListDetailReducer';
import sanctionAssociateReducer from './sanctionAssociateReducer';
import sanctionFieldsReducer from './sanctionFieldsReducer';
import sanctionsReducer from './sanctionsReducer';
import draftStatusReducer from './draftStatusReducer';
import complianceReducer from './complianceReducer';
import currenciesReducer from './currenciesReducer';
import mastersReducer from './mastersReducer';
import appBuildersReducer from './appBuildersReducer';
import listsReducer from './listsReducer';
import filterFieldsReducer from './filterFieldsReducer';
import masterCountriesReducer from './masterCountriesReducer';
import complianceInternalBlockReducer from './complianceInternalBlockReducer';
import channelAccountRestrictionTypesReducer from './channelAccountRestrictionTypesReducer';
import uploadTransactionReducer from './uploadTransactionReducer';
import objectStorageReducer from './objectStorageReducer';

import commandsReducer, { commandTypesReducer } from './commandsReducer';
import bannersReducer, { bannerTypesReducer } from './bannersReducer';
import emiSchemesReducer, { emiSchemeTypesReducer } from './emiSchemesReducer';
import commandFilterFieldsReducer from './commandFilterFieldsReducer';
import binReducer from './binReducer';
import { emiTransactionReducer, bnplListReducer } from './emiTransactionReducer';
import {
  settlementReducer,
  settlementDetailReducer,
  settlementAccountTransactionsReducer,
  settlementAttemptDetailReducer,
  settlementDraftReducer,
  settlementDraftDetailReducer,
} from './settlementReducer';
import qrProviderReducer from './qrProvidersReducer';
import merchantSchemesReducer, { merchantSchemeListReducer } from './merchantSchemesReducer';
import notificationReducer, {
  notificationTypesReducer,
  notificationActionReducer,
  notificationMerchantReducer,
  notificationAppReducer,
  notificationIntervalReducer,
} from './notificationReducer';

import notificationAuditLogReducer from './notificationAuditLogReducer';

import bankIntegrationReducer from './bankIntegrationReducer';
import terminalChartSummaryReducer from './terminalChartSummaryReducer';
import terminalActionDropdownReducer from './terminalActionDropdownReducer';
import {
  cardSettlementGroupByReducer,
  cardSettlementMccDropdownReducer,
  cardSettlementReducer,
  cardSettlementReportBatchListReducer,
  cardSettlementReportDraftSummaryListReducer,
  cardSettlementReportDraftSummaryReducer,
  cardSettlementReportReducer,
  merchantCardSettlementDetailsReducer,
  merchantCardSettlementDropdownReducer,
  merchantCardSettlementReducer,
} from './cardSettlementReducer';
import {
  transactionBarGraphCurrencyDropDownReducer,
  transactionBarGraphDropDownReducer,
  transactionBarGraphReducer,
} from './transactionBarGraphReducer';
import receiptConfigurationReducer from './receiptConfigurationReducer';

import provinceReducer from './provinceDistrictReducer';
import mccChartSummaryReducer from './mccChartSummary';
import mccDetailReducer from './mccDetailReducer';
import memberBankReducer from './memberBankReducer';
import {
  qrSettlementReportReducer,
  qrSettlementIndividualReportReducer,
} from './qrSettlementReportReducer';
import terminalInstalledAppTabsReducer from './teminalInstalledAppsTabReducer';
import terminalInstalledAppFilterFieldReducer from './terminalInstalledAppsFilterFieldReducer';
import terminalMemberBankReducer from './terminalMemberBankReducer';
// support reducer
import {
  supportReducer,
  supportPriorityReducer,
  supportReportToReducer,
  supportAssignToReducer,
  supportStaffReducer,
  supportEditReducer,
  supportUpdateReducer,
  supportTicketTypeReducer,
  supportDetailsReducer,
  supportTicketStatusReducer,
  updateSupportTicketStatusReducer,
  editSupportTicketReducer,
  supportTicketSummaryReducer,
  supportMerchantListReducer,
} from './supportReducer';
import terminalManualEnabledReducer from './terminalManualEnabledReducer';
import terminalSummaryReducer from './terminalSummaryReducer';
import terminalSummaryListReducer from './terminalSummaryListReducer';

import terminalLogsFilterFieldReducer from './terminalLogsFilterFieldReducer';
import terminalLogsReducer from './terminalLogsReducer';
import {
  devicePasswordSetupDraftDetailsReducer,
  devicePasswordSetupDraftReducer,
  devicePasswordSetupReducer,
} from './devicePasswordSetupReducer';
import operatorPlusGroupsDraftDetailsReducer from './operatorPlusGroupDraftDetails';
import {
  superMerchantReducer,
  superMerchantDetailsReducer,
  superMerchantExpandedDetailsReducer,
  masterMerchantGroupListReducer,
  createMasterMerchantReducer,
  editMasterMerchantReducer,
} from './superMerchantReducer';
import billingReducer from './billingVendorReducer';
import billingVendorAddReducer from './billingVendorAddReducer';
import billingSystemAddReducer from './billingSystemAddReducer';
import billingVendorReducer from './billingVendorReducer';
import billingSystemReducer from './billingSystemReducer';
import billingTransactionReducer from './billingTransactionReducer';
import subOperatorsReducer from '../components/User/merchant-user/subOperatorReducer';

const appReducer = combineReducers({
  router: connectRouter(history),
  ui: uiReducer,
  users: usersReducer,
  subOperator: subOperatorsReducer,
  userTypes: userTypesReducer,
  userFilterFields: userFilterFieldsReducer,
  passwordPolicies: passwordPoliciesReducer,
  roles: rolesReducer,
  roleFilterFields: roleFilterFieldsReducer,
  permissions: permissionsReducer,
  fields: customFieldsReducer,
  dataTypes: customFieldDataTypesReducer,
  validationRules: customFieldValidationRulesReducer,
  modules: customFieldModulesReducer,
  branches: branchesReducer,
  branchFilterFields: branchFilterFieldsReducer,
  operators: operatorsReducer,
  superMerchant: superMerchantReducer,
  addMasterMerchant: createMasterMerchantReducer,
  editMasterMerchant: editMasterMerchantReducer,
  superMerchantDetails: superMerchantDetailsReducer,
  superMerchantExpandedDetails: superMerchantExpandedDetailsReducer,
  masterMerchantGroupList: masterMerchantGroupListReducer,
  operatorCharts: operatorChartsReducer,
  operatorGroups: operatorGroupsReducer,
  operatorsPlusGroupDraftDetails: operatorPlusGroupsDraftDetailsReducer,
  operatorFilterFields: operatorFilterFieldsReducer,
  departments: departmentsReducer,
  departmentFilterFields: departmentFilterFieldsReducer,
  entitySummaries: entitySummariesReducer,
  appCharts: appChartsReducer,
  appReports: appReportsReducer,
  appReportFilterFields: appReportFilterFieldsReducer,
  appReportDetails: appReportDetailsReducer,
  transactions: transactionReducer,
  todayTransactions: todaytransactionReducer,
  monthlyTransactions: monthlytransactionReducer,
  allTransactions: allTransactionReducer,
  paymentRequestTransactions: transactionPaymentReducer,
  summaryTransactions: hitCountTransactionReducer,
  watchListTransactions: watchListTransactionReducer,
  todayCountAmountTxn: todayCountAmountTransactionReducer,
  monthlyCountAmountTxn: monthlyCountAmountTransactionReducer,
  allCountAmountTxn: allCountAmountTransactionReducer,
  countAmountTxnSummary: countAmountTransactionSummaryReducer,
  activityLogs: activityLogReducer,
  transactionFilterFields: transactionFilterFieldsReducer,
  transactionsCount: transactionCountsReducer,
  transactionSummaries: transactionSummariesReducer,
  transactionRules: transactionRulesReducer,
  transactionRuleApps: transactionRuleAppsReducer,
  transactionRuleApplicableGroups: transactionRuleApplicableGroupsReducer,
  transactionRuleCommissionBasis: transactionRuleCommissionBasisReducer,
  transactionRuleCommissionTypes: transactionRuleCommissionTypesReducer,
  transactionRuleFeeCharges: transactionRuleFeeChargesReducer,
  transactionRuleFilterFields: transactionRuleFilterFieldsReducer,
  terminals: terminalsReducer,
  terminalsKcv: terminalKcvReducer,
  terminalTypes: terminalTypesReducer,
  terminalLocations: terminalLocationsReducer,
  terminalInstalledApps: terminalInstalledAppsReducer,
  terminalInstalledAppEvents: terminalInstalledAppEventsReducer,
  terminalInstalledAppLogs: terminalInstalledAppLogsReducer,
  terminalFilterFields: terminalFilterFieldsReducer,
  terminalLocks: terminalLocksReducer,
  terminalResets: terminalResetsReducer,
  terminalGeoFencings: terminalGeoFencingsReducer,
  platformCertificates: platformCertificatesReducer,
  platformCertificatesFilterFields: platformCertificateFilterFieldsReducer,
  firmwares: firmwaresReducer,
  firmwareFilterFields: firmwareFilterFieldsReducer,
  terminalModels: terminalModelsReducer,
  terminalModelFilterFields: terminalModelFilterFieldsReducer,
  customers: customersReducer,
  customerFilterFields: customerFilterFieldsReducer,
  customerEnrollments: customerEnrollmentsReducer,
  mto: mtoReducer,
  mtoFilterFields: mtoFilterFieldsReducer,
  countries: countriesReducer,
  messaging: messagingReducer,
  messagingFilterFields: messagingFilterFieldsReducer,
  messagingParameterTypes: messagingParameterTypesReducer,
  apps: appsReducer,
  appCategoryCharts: appCategoryChartsReducer,
  appFilterFields: appFilterFieldsReducer,
  appBroadcasts: appBroadcastsReducer,
  userDetails: userDetailsReducer,
  switches: switchesReducer,
  integrationCodeTypes: integrationCodeTypesReducer,
  terminalLocationEvents: terminalLocationEventsReducer,
  switchTypes: switchTypesReducer,
  switchKeyEncryptionTypes: switchKeyEncryptionTypesReducer,
  switchKeyCertificateFactoryTypes: switchKeyCertificateFactoryTypesReducer,
  switchKeyVersions: switchKeyVersionsReducer,
  switchFilterFields: switchFilterFieldsReducer,
  generalSettings: generalSettingsReducer,
  billingSystem: billingSystemReducer,
  billingTransaction: billingTransactionReducer,
  billingVendor: billingVendorReducer,
  billingVendorAdd: billingVendorAddReducer,
  billingSystemAdd: billingSystemAddReducer,
  systemSettings: systemSettingsReducer,
  accountTypes: accountTypesReducer,
  productTypes: productTypesReducer,
  channels: channelsReducer,
  channelFilterFields: channelFilterFieldsReducer,
  channelTypes: channelTypesReducer,
  channelMethodTypes: channelMethodTypesReducer,
  channelProtocolTypes: channelProtocolTypesReducer,
  channelActionOnRuleViolationTypes: channelActionOnRuleViolationTypesReducer,
  sanctions: sanctionsReducer,
  sanctionAssociates: sanctionAssociateReducer,
  sanctionListDetails: sanctionListDetailReducer,
  sanctionFields: sanctionFieldsReducer,
  draftStatus: draftStatusReducer,
  compliance: complianceReducer,
  currencies: currenciesReducer,
  masters: mastersReducer,
  appBuilders: appBuildersReducer,
  lists: listsReducer,
  filterFields: filterFieldsReducer,
  masterCountries: masterCountriesReducer,
  complianceInternalBlocks: complianceInternalBlockReducer,
  channelAccountRestrictionTypes: channelAccountRestrictionTypesReducer,

  commands: commandsReducer,
  commandTypes: commandTypesReducer,
  commandFilterFields: commandFilterFieldsReducer,

  banners: bannersReducer,
  bannerTypes: bannerTypesReducer,

  objectStorage: objectStorageReducer,
  emiSchemes: emiSchemesReducer,
  emiSchemeTypes: emiSchemeTypesReducer,
  auditLogs: auditLogReducer,
  bins: binReducer,
  emiTransactions: emiTransactionReducer,
  bnplList: bnplListReducer,
  settlements: settlementReducer,
  settlementsDraft: settlementDraftReducer,
  settlementsDraftDetail: settlementDraftDetailReducer,
  settlementAttemptDetails: settlementAttemptDetailReducer,
  settlementAccountTransactions: settlementAccountTransactionsReducer,
  qrSettlementReport: qrSettlementReportReducer,
  qrSettlementIndividualReport: qrSettlementIndividualReportReducer,
  settlementDetails: settlementDetailReducer,
  qrProviders: qrProviderReducer,
  merchantSchemes: merchantSchemesReducer,
  merchantSchemeList: merchantSchemeListReducer,
  notifications: notificationReducer,
  notificationTypes: notificationTypesReducer,
  notificationAction: notificationActionReducer,
  notificationMerchant: notificationMerchantReducer,
  notificationApp: notificationAppReducer,
  notificationInterval: notificationIntervalReducer,
  notificationAuditLog: notificationAuditLogReducer,
  uploadTransaction: uploadTransactionReducer,
  bankIntegration: bankIntegrationReducer,
  terminalChartSummary: terminalChartSummaryReducer,
  terminalActionDropdown: terminalActionDropdownReducer,
  cardSettlement: cardSettlementReducer,
  cardSettlementReport: cardSettlementReportReducer,
  cardSettlementReportBatchList: cardSettlementReportBatchListReducer,
  cardSettlementReportDraftSummary: cardSettlementReportDraftSummaryReducer,
  cardSettlementReportDraftSummaryList: cardSettlementReportDraftSummaryListReducer,
  cardSettlementGroupBy: cardSettlementGroupByReducer,
  cardSettlementMcc: cardSettlementMccDropdownReducer,
  receiptConfiguration: receiptConfigurationReducer,
  transactionBarGraphDropDown: transactionBarGraphDropDownReducer,
  transactionBarGraph: transactionBarGraphReducer,
  transactionBarGraphCurrencyDropDown: transactionBarGraphCurrencyDropDownReducer,
  provinceDistrict: provinceReducer,
  mccChartSummary: mccChartSummaryReducer,
  mccDetail: mccDetailReducer,
  memberBank: memberBankReducer,
  terminalInstalledAppsTab: terminalInstalledAppTabsReducer,
  appListFilterField: terminalInstalledAppFilterFieldReducer,
  terminalMemberBank: terminalMemberBankReducer,
  supportTicketSummary: supportTicketSummaryReducer,
  support: supportReducer,
  supportDetails: supportDetailsReducer,
  updateSupportTicketStatus: updateSupportTicketStatusReducer,
  editSupportTicket: editSupportTicketReducer,
  priority: supportPriorityReducer,
  ticketType: supportTicketTypeReducer,
  ticketStatus: supportTicketStatusReducer,
  merchantList: supportMerchantListReducer,
  reporter: supportReportToReducer,
  assignee: supportAssignToReducer,
  supportStaff: supportStaffReducer,
  supportEdit: supportEditReducer,
  supportUpdate: supportUpdateReducer,
  merchantCardSettlementDropDown: merchantCardSettlementDropdownReducer,
  merchantCardSettlement: merchantCardSettlementReducer,
  merchantCardSettlementDetails: merchantCardSettlementDetailsReducer,
  terminalLogs: terminalLogsReducer,
  terminalLogsFilterField: terminalLogsFilterFieldReducer,
  terminalManualEnabled: terminalManualEnabledReducer,
  terminalSummary: terminalSummaryReducer,
  terminalSummaryList: terminalSummaryListReducer,
  devicePasswordSetup: devicePasswordSetupReducer,
  devicePasswordSetupDraftList: devicePasswordSetupDraftReducer,
  devicePasswordSetupDraftDetails: devicePasswordSetupDraftDetailsReducer,
});

const rootReducer = (state, action) => {
  if (action && action.type === 'LOG_OUT_SUCCESS') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
